import { MantineColor } from '@mantine/core';
import Badge from './Badge';

export default Badge;

export interface BadgeProps {
  color?: MantineColor;
  backgroundColor?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  variant?: string;
}
